import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=585de67c&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('585de67c')) {
      api.createRecord('585de67c', component.options)
    } else {
      api.reload('585de67c', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=585de67c&", function () {
      api.rerender('585de67c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27LnDkt6wb5zl/JS/comp/ImgFallback.vue"
export default component.exports